import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ totalStars, smsToday, smsMonth, pricePerSms, totalGanhoHoje }) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');

  // Função para formatar valores monetários com vírgulas em vez de pontos
  const formatCurrency = (value) => {
    return typeof value === 'number' ? value.toFixed(2).replace('.', ',') : value;
  };

  return (
    <header className="bg-gray-100 text-gray-800 p-4 flex flex-col items-center">
      <div className="w-full max-w-xs">
        {/* Exibindo saudação e total a receber */}
        <div className="p-2 my-1 rounded-lg flex items-center">
          <span className="text-sm font-semibold">Olá, {userName}</span>
        </div>
        {/* Exibindo os demais itens */}
        {[
          { icon: '💵', label: 'Total à Receber:', value: `R$ ${formatCurrency(totalStars)}` },
          { icon: '📨', label: 'SMS Hoje:', value: `${smsToday}/500` },
          { icon: '💰', label: 'Ganho Hoje:', value: `R$ ${formatCurrency(totalGanhoHoje)}` },
          { icon: '💲', label: 'Preço por SMS:', value: `R$ ${formatCurrency(pricePerSms)}` },
        ].map((item, index) => (
          <div 
            key={index} 
            className="bg-gray-200 border border-gray-300 p-2 my-1 rounded-lg flex items-center justify-between"
          >
            <div className="flex items-center">
              <span className="text-xl mr-2">{item.icon}</span>
              <span className="text-sm font-semibold">{item.label}</span>
            </div>
            <span className="text-lg font-semibold">{item.value}</span>
          </div>
        ))}
      </div>
    </header>
  );
};

export default Header;
